import { I18n } from 'i18n-js'
import translations from './translations.json'

const i18n = new I18n(translations)

i18n.defaultLocale = 'vi'
i18n.locale = 'vi'

export default i18n
